import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { useEffect } from "react";

import { login } from "../../shopify.server";

import "./bootstrap.css";
import "./styles.css";
import "./animate.css";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return json({ showForm: Boolean(login) });
};

export default function App() {
  const { showForm } = useLoaderData<typeof loader>();

  useEffect(() => {
    const scripts = [
      "/js/jquery-1.11.2.min.js",
      "/js/jquery.magnific-popup.min.js",
      "/js/jquery.easing.min.js",
      "/js/wow.min.js",
      "/js/bootstrap.min.js",
      "/js/main.js",
    ];

    scripts.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      document.body.appendChild(script);
    });

    return () => {
      // Clean up scripts when the component unmounts
      scripts.forEach((src) => {
        const scriptElements = document.querySelectorAll(`script[src="${src}"]`);
        scriptElements.forEach((script) => {
          document.body.removeChild(script);
        });
      });
    };
  }, []);

  const year = new Date().getFullYear();

  return (
    <>
  <div id="loader-wrapper">
    <div id="loader" />
  </div>
  {/* End: Preloader section */}
  {/* DOCUMENT WRAPPER STARTS */}
  <main>
    {/* MAIN HEADER STARTS*/}
    <header id="header">
      {/* TOP NAVIGATION */}
      <nav className="top-navigation-bar navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {/* Brand and toggle get grouped for better mobile display */}
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#top-navigation-bar"
                  aria-expanded="false"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <a className="navbar-brand" href="/">
                  Scribify <span className="thin">for Shopify</span>
                </a>
              </div>
              {/* Collect the nav links, forms, and other content for toggling */}
              <div className="collapse navbar-collapse" id="top-navigation-bar">
                <ul className="nav navbar-nav navbar-right">
                  <li className="active">
                    <a href="https://apps.shopify.com/scribify">Add to Shopify</a>
                  </li>
                  {/*li><a href="about.html">about Us</a></li>
                      <li><a href="contact.html">Get in Touch</a></li*/}
                </ul>
              </div>
              {/* /.navbar-collapse */}
            </div>
          </div>
        </div>
        {/* /.container*/}
      </nav>
      {/* TOP NAVIGATION ENDS */}
    </header>
    {/* main header ends*/}
    <section id="banner" className="banner">
      <div className="container">
        <div
          id="ghughu-banner-carousel"
          className="carousel slide carousel-fade"
          data-ride="carousel"
        >
          {/* Indicators */}
          <ol className="carousel-indicators">
            <li
              data-target="#ghughu-banner-carousel"
              data-slide-to={0}
              className="active"
            />
            <li data-target="#ghughu-banner-carousel" data-slide-to={1} />
            <li data-target="#ghughu-banner-carousel" data-slide-to={2} />
          </ol>
          {/* Wrapper for slides */}
          <div className="carousel-inner full-height" role="listbox">
            <div className="item active banner-item">
              <div className="row">
                <div className="col-sm-7">
                  <h1 className="animated fadeInUp delay-2">
                    Embed your email list within your shop in minutes.
                  </h1>
                  <p className="animated fadeInUp delay-3">
                    Scribify is a Shopify app that makes it easy for customers
                    to browse your ongoing promotions and past email list
                    content.
                  </p>
                </div>
                <div className="col-sm-5 text-center hidden-xs">
                  <img
                    src="images/banner-carousel/browser.png"
                    className="animated fadeInUp delay-4 img-responsive"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
            <div className="item banner-item">
              <div className="row">
                <div className="col-sm-7">
                  <h1 className="animated fadeInUp delay-2">
                    Keep an archive of your customer outreach
                  </h1>
                  <p className="animated fadeInUp delay-3">
                    Straightforward email management, with options to delete or
                    hide specific emails. We'll securely archive media to keep
                    your content safe.
                  </p>
                </div>
                <div className="col-sm-5 text-center hidden-xs">
                  <img
                    src="images/banner-carousel/mobile.jpeg"
                    className="animated fadeInUp delay-4 img-responsive"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
            <div className="item banner-item">
              <div className="row">
                <div className="col-sm-7">
                  <h1 className="animated fadeInUp delay-2">
                    AI-powered tools do the hard work.
                  </h1>
                  <p className="animated fadeInUp delay-3">
                    Scribify's advanced filtering engine automatically removes
                    unsubscribe links and strips tracking pixels, preserving the
                    integrity of your outreach and analytics.
                  </p>
                </div>
                <div className="col-sm-5 text-center hidden-xs">
                  <img
                    src="images/banner-carousel/flowchart.png"
                    className="animated fadeInUp delay-4 img-responsive"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Controls */}
        <a
          className="left carousel-control"
          href="#ghughu-banner-carousel"
          role="button"
          data-slide="prev"
        >
          <i>
            <img src="images/banner-carousel/arrow-left.svg" alt="icons" />
          </i>
        </a>
        <a
          className="right carousel-control"
          href="#ghughu-banner-carousel"
          role="button"
          data-slide="next"
        >
          <i>
            <img src="images/banner-carousel/arrow-right.svg" alt="banner" />
          </i>
        </a>
      </div>
    </section>
    <section id="who-are-we" className="who-are-we page">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-sm-5 col-md-6">
            <h1>
              Backed by
              <br />
              industry pros.
            </h1>
          </div>
          <div className="col-sm-7 col-md-6">
            <p>
              Scribify is built by{" "}
              <a href="https://zingstudios.com">Zing Studios</a>, a custom web
              development firm with over 10 years of experience in e-commerce
              and email marketing tools. We pride ourselves on our close
              relationships with customers and fast response times to support
              queries.
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* most probably like canvas */}
    <section id="services" className="services page">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-md-12 main-heading">
            <h1>Simple and powerful</h1>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="service clearfix">
                <div className="col-sm-4 col-md-5">
                  <span className="service-number">1</span>
                </div>
                <div className="col-sm-8 col-md-7">
                  <h2>Setup in minutes with your existing email list</h2>
                  <p>
                    Scribify takes minutes to setup: just subscribe the
                    dedicated email address we provide to your existing list and
                    drag-and-drop the widget into your Shopify theme.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="service clearfix">
                <div className="col-sm-4 col-md-5">
                  <span className="service-number">2</span>
                </div>
                <div className="col-sm-8 col-md-7">
                  <h2>Straightforward pricing with no added fees</h2>
                  <p>
                    For just $29/month or $299/year, get unlimited emails and
                    widget embeds. We'll archive all media securely in the cloud
                    to keep your content safe. Install today to get a 7-day free
                    trial with no restrictions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="service clearfix">
                <div className="col-sm-4 col-md-5">
                  <span className="service-number">3</span>
                </div>
                <div className="col-sm-8 col-md-7">
                  <h2>Advanced features and AI-powered filtering</h2>
                  <p>
                    Scribify provides a simple email management interface with
                    all you need to ensure your emails are displayed correctly
                    and securely. Our advanced filtering engine automatically
                    removes unsubscribe links and tracking pixels.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* CTA section starts */}
    <section id="cta" className="cta page">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-sm-6">
            <h1>Get Scribify</h1>
          </div>
          <div className="col-sm-6">
            <a className="btn btn-block custom-button" href="https://apps.shopify.com/scribify">
              Add to Shopify
            </a>
          </div>
        </div>
        {/* End: .row */}
      </div>
      {/* End: .container*/}
    </section>
    {/* CTA section ends */}
    {/* footer section starts */}
    <footer id="footer" className="footer">
      <div className="container">
        <div className="row">
          <div className="footer-wrapper clearfix page wow fadeInUp">
            <div className="col-md-6 footer-left">
              <div className="row">
                <div className="col-xs-6">
                  <div className="footer-link footer-link-1">
                    <h4>Links</h4>
                    <ul>
                      <li>
                        <a href="/privacy">Privacy policy</a>
                      </li>
                      <li>
                        <a href="mailto:scribify@zingstudios.com">
                          Get in touch
                        </a>
                      </li>
                      <li>
                        <a href="https://zingstudios.com" target="_blank">
                          Zing Studios
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xs-6"></div>
              </div>
            </div>
            <div className="col-md-5 col-md-offset-1 footer-text">
              <p>
                Scribify is a Zing Studios creation. All rights reserved.
                <br />
                Shopify is a registered trademark of Shopify Inc. and is not
                affiliated with Scribify or Zing Studios.
              </p>
              <span>
                Copyright © {year}{" "}
                <a href="https://zingstudios.com/" target="_blank">
                  Zing Studios
                </a>
              </span>
            </div>
          </div>
        </div>
        {/* End: .row */}
      </div>
      {/* End: .container*/}
    </footer>
    {/* footer section ends */}
  </main>
</>

  );
}
